import { render, staticRenderFns } from "./wlCompany.vue?vue&type=template&id=7a73a187&scoped=true&"
import script from "./wlCompany.vue?vue&type=script&lang=js&"
export * from "./wlCompany.vue?vue&type=script&lang=js&"
import style0 from "./wlCompany.vue?vue&type=style&index=0&id=7a73a187&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73a187",
  null
  
)

export default component.exports